/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  /**
   * Replaces "Chatwoot" in text with the installation name from global config
   * @param {string} text - The text to process
   * @returns {string} - Text with "Chatwoot" replaced by installation name
   */
  const replaceInstallationName = text => {
    if (!text) return text;

    const installationName = globalConfig.value?.installationName;
    let result = text;
    if (installationName) {
      result = result.replace(/Chatwoot/gi, installationName);
    }

    const appHost = typeof window !== 'undefined' ? window.location?.host : null;
    if (appHost) {
      result = result.replace(/app\.chatwoot\.com/gi, appHost);
      result = result.replace(/\{host\}/g, appHost);
    }

    return result;
  };

  return {
    replaceInstallationName,
  };
}
